import * as React from "react"
import { ChevronDownIcon } from "@radix-ui/react-icons"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Badge } from "./badge"

export type OptionType = {
  label: React.ReactNode | string;
  value: string;
};

interface MultiSelectProps {
  options: OptionType[];
  selected: string[];
  onChange: React.Dispatch<React.SetStateAction<string[]>>;
  className?: string;
}

export function MultiSelect({ options, selected, onChange }: MultiSelectProps) {
  const handleUnselect = (item: string) => {
    onChange(selected.filter((i) => i !== item))
  }

  const handleSelect = (item: string) => {
    onChange([...selected, item])
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          className={`w-full justify-between h-full p-1`}
        >
          <div className="flex gap-1 flex-wrap">
            {selected.map((item) => (
              <Badge
                variant="secondary"
                key={item}
                onClick={() => handleUnselect(item)}
              >
                {options.find((option) => option.value === item)?.label}
              </Badge>
            ))}
          </div>
          <ChevronDownIcon className="h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="">
        {options.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            checked={
              selected.find((item) => item === option.value) ? true : false
            }
            onCheckedChange={(checked) => {
              if (checked) {
                handleSelect(option.value)
              } else {
                handleUnselect(option.value)
              }
            }}
          >
            {option.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
